import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {PermissionModule} from "../permission/permission.module";
import {FormsModule} from "@angular/forms";
import {DummyCheckboxComponent} from "./dummyCheckboxComponent/dummyCkeckbox.component";
import {MatCheckboxModule} from "@angular/material/checkbox";

@NgModule({
    declarations: [
        DummyCheckboxComponent
    ],
    entryComponents: [
        DummyCheckboxComponent
    ],
    exports: [
        DummyCheckboxComponent
    ],
    imports: [
        CommonModule,
        PermissionModule,
        FormsModule,
        MatCheckboxModule,
    ],
})
export class DummyCheckboxModule { }